module.exports = __webpack_public_path__ + "img/card-product3.1cd31fc0.jpg";